/* eslint-disable no-alert */
/* eslint-disable no-console */
import React from 'react';
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { geolocated, geoPropTypes } from 'react-geolocated';
import Box from 'ui-box';
import { Row, Typography, Button, Space } from 'antd';
import { getLocationData } from '../../../../api';
import useLocation from '../../../../containers/hooks/useLocation';
import { ReactComponent as LocationSvg } from '../../../../assets/icons/sign-up/location.svg';

const { Title, Paragraph } = Typography;

const styles = {
  text1: {
    fontWeight: "500",
    fontSize: "14px",
    lineHeight: "17px",
    textAlign: "center",
    color: "#15A9E1"
  },
  text2: {
    fontWeight: "300",
    fontSize: "18px",
    lineHeight: "26px",
    textAlign: "center",
    color: "#404047"
  },
  text3: {
    fontWeight: "300",
    fontSize: "14px",
    lineHeight: "20px",
    textAlign: "center",
    color: "#8C8C8C"
  }
}

function MobileLocationAccessRequestScreen({
  coords,
  isGeolocationAvailable,
  isGeolocationEnabled,
}) {
  const { t } = useTranslation(['sign-up', 'common']);
  const { setLocation } = useLocation();
  const history = useHistory();

  const onConfirm = async () => {
    const latitude = coords?.latitude
    const longitude = coords?.longitude
    try {
      const { provinceName, countryName, countryCode } = await getLocationData(
        latitude,
        longitude
      );
      setLocation({ latitude, longitude, provinceName, countryName, countryCode });
      history.push('/sign-up/guest/screening-request')
    } catch (err) {
      console.error(err)
      alert(t('common:form.error.submit'));
    }
  }

  const onCancel = () => {
    history.push('/sign-up/guest/screening-request')
  }

  const renderGeolocationStatus = () => {
    if (!isGeolocationAvailable) {
      return <div>{t('common:form.error.geolocation')}</div>;
    }

    if (!isGeolocationEnabled) {
      return <div>{t('common:form.error.location')}</div>;
    }

    return null;
  };

  return (
    <>
      <Row justify="center" style={{ padding: 0, marginBottom: 23 }}>
        <Title level={4} style={styles.text1}>
          {t('sign-up:guest.locationAccess')}
        </Title>
      </Row>
      <Box display="flex" justifyContent="center">
        <LocationSvg style={{ margin: '20', maxWidth: '80%' }} />
      </Box>
      <Box marginTop={30}>
        <Box marginBottom={45}>
          <Paragraph style={styles.text2}>
            {t('sign-up:guest.willYouShareLocation')}
          </Paragraph>
        </Box>
        <Box marginBottom={50}>
          <Paragraph style={styles.text3}>
            {t('sign-up:guest.theInformationPrivate')}
          </Paragraph>
        </Box>
        <Space direction="vertical" style={{ width: '100%' }}>
          <Button
            htmlType="button"
            type="primary"
            size="large"
            onClick={onConfirm}
            block
          >
            {t('common:button.yes')}
          </Button>
          <Button
            htmlType="button"
            type="primary"
            size="large"
            onClick={onCancel}
            block
            ghost
          >
            {t('common:button.no')}
          </Button>
        </Space>
        {renderGeolocationStatus()}
      </Box>
    </>
  );
}

MobileLocationAccessRequestScreen.propTypes = geoPropTypes;

export default geolocated({
  positionOptions: {
    enableHighAccuracy: false,
  },
  suppressLocationOnMount: false,
  isOptimisticGeolocationEnabled: true,
})(MobileLocationAccessRequestScreen);
